define('shared/initializer/form/adapters/Payment',[
    '../constants',
    '$',
    './Checkout',
    './mixins/OfferValidatable',
    './mixins/UpdateMemberInfoInPaymentPage',
    './mixins/PaymentOfferIdSubmittable',
    'shared/lib/ctor',
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/lib/console',
    'shared/my/identity',
    'shared/util/checkout/checkout',
    'Promise'
],
function ( 
    constants, 
    $,
    Checkout, 
    OfferValidatable,
    UpdateMemberInfoInPaymentPage,
    PaymentOfferIdSubmittable,
    ctor, 
    RSVP, 
    state,
    console,
    getIdentity,
    checkoutUtil,
    Promise
) {
    'use strict';

    var Ctor = ctor(function() {

        var me = this;
        me.base.apply(me, arguments);

        me.mixin(
            PaymentOfferIdSubmittable,
            OfferValidatable,
            UpdateMemberInfoInPaymentPage
        );

    }).inherit(Checkout);

    var p = Ctor.prototype;

    p.doPageLoad = function(){
        var me = this;
        return Checkout.prototype.doPageLoad.apply(me, arguments)
            .then(function(){
                return getIdentity();
            })
            .then(function(memberId){
                me.$form.find('[name="' + constants.FIELD.MEMBER_ID + '"]').val(memberId);
                me.$form.find('[name="' + constants.FIELD.PURCHASEINFO_MEMBERID + '"]').val(memberId);
            });
    };

    p.doSubmit = function() {
        var me = this;
        return Checkout.prototype.doSubmit.apply(me, arguments)
            .then(function(){
                return RSVP.all(me.dfdOfferValidatable);
            });
    };

    p.doBeforeRedirect = function( data ){
        console.log('Payment doBeforeRedirect received data:', data);

        return new Promise(function (rs, rj) {
            if(data && data.Result){
                var orderId = data.Result;
                checkoutUtil
                    .handlePaymentSucceeded
                    .call(this, orderId)
                    .then(rs, rj);
            }
            else{
                return rj('Order id cannot be found');
            }
        })
        .then(function () {
            return data;
        });
    };

    return Ctor;
});
